import { ProductCartContextProvider } from "./contaxt/CartProductContext"
import { Helmet, HelmetProvider } from "react-helmet-async";
import MyRoutes from "routers/index";
import { useCallback, useEffect, useState } from "react";
import { OnlineOrderSettingsProvider } from "./contaxt/OnlineOrderSettingsContext";
import Cookies from "js-cookie";
import { MenuScheduleProvider } from "./contaxt/MenuScheduleContext";
function App() {

  const title = Cookies.get("onlineOrderSettingsTitleText") ?? null;
  const [titletext, setTitletext] = useState(title);
  const isDark = Cookies.get("theme");
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  const handleSystemMode = useCallback(() => {
    if (mediaQuery.matches) {
      document.documentElement.classList.add("dark");
      document.documentElement.classList.remove("light");
    } else {
      document.documentElement.classList.add("light");
      document.documentElement.classList.remove("dark");
    }
  }, [isDark, mediaQuery]);

  useEffect(() => {
    if (isDark === "system") {
      mediaQuery.addEventListener("change", handleSystemMode);
      handleSystemMode();
      return () => {
        mediaQuery.removeEventListener("change", handleSystemMode);
      };
    } else {
      if (isDark === "dark") {
        document.body.classList.add("dark");
        document.body.classList.remove("light");
      } else if (isDark === "light") {
        document.body.classList.add("light");
        document.body.classList.remove("dark");
      }
    }
  }, [isDark, handleSystemMode]);
  useEffect(() => {
    if (!Cookies.get("theme")) {
      Cookies.set("theme", "system");
      mediaQuery.addEventListener("change", handleSystemMode);
      handleSystemMode();
      return () => {
        mediaQuery.removeEventListener("change", handleSystemMode);
      };
    }
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="theme-color" content="#000000" />
        <meta name="description" content="Basil POS Online Ordering" />
        <title>{titletext}</title>
      </Helmet>
      <OnlineOrderSettingsProvider>
      <MenuScheduleProvider>
        <ProductCartContextProvider>
          <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
            <MyRoutes />
          </div>
        </ProductCartContextProvider>
        </MenuScheduleProvider>
      </OnlineOrderSettingsProvider>
    </HelmetProvider>
  );
}

export default App;
